import {MediaQueries} from '../../infra/mediaQueries.service';
import {Component, Inject, Input} from 'ng-metadata/core';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';


@Component({
    selector: 'prm-banner-card-content',
    templateUrl: 'components/search/resourceRecommender/banner-card-content.html',
})

export class PrmBannerCardContent {
    @Input() private banner;

    constructor(private primolyticsService: PrimolyticsService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        this.bannerDisplayedBeacon();
    }

    ngOnInit() {
        this.changeBannerToRegularDiv();
        this.$timeout(() => {
            this.removeUnnecessaryAttributes();
        }, 100);
    }

    private onBannerClick() {
        this.onBannerClickBeacon();
    }

    @beacon({'p': 'brief', 'op': 'resourceRecommenderBanner'})
    private onBannerClickBeacon() {
    }

    @beacon({'p': 'brief', 'op': 'resourceRecommenderBannerDisplayed'})
    private bannerDisplayedBeacon() {
    }

    private changeBannerToRegularDiv() {
        if (!this.banner.url) {
            let pageElement = document.getElementById('rscBanner');
            pageElement.outerHTML = pageElement.outerHTML.replace("a", "div");
        }
    }

    private removeUnnecessaryAttributes() {
        if (!this.banner.url) {
            let elem = document.getElementById("rscBanner");
            elem.removeAttribute("role");
            elem.removeAttribute("tabindex");
            elem.removeAttribute("target");
        }
    }

}






// WEBPACK FOOTER //
// ./src/main/webapp/components/search/resourceRecommender/bannerCardContent.directive.ts